<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Documents</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employeeId"></employee-sidebar>
      <div class="emplyee-info-wrp">
        <div class="main-box hour-head-info">
          <div class="text-wrapper">
            <div class="hour-list">
              <div class="emp-button btn-align text-right">
                <button type="button" data-toggle="modal" data-target="#createDocumentModal" class="btn btn-outline-primary">
                  Create New Document
                </button>
              </div>
            </div>
          </div>
        </div>
        <document-list></document-list>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentList from "./doucments/documentList";
import employeeSidebar from "../Employees/employeeSidebar";

export default {
  name: "EmployeeDocuments",
  components: {
    employeeSidebar,
    DocumentList,
  },
  data() {
    return {
      user: this.$store.getters.getUser,
      employeeId: this.$store.getters.getEmployeeProfileId,
    };
  },
};
</script>
